export const DictItemCode = {
    VMS_INVITE_PROPERTIES_VISITOR_ID_FIELD_VISIBLE: 'VMS_INVITE_PROPERTIES_VISITOR_ID_FIELD_VISIBLE',
    VMS_INVITE_PROPERTIES_VISITOR_EMAIL_FIELD_VISIBLE: 'VMS_INVITE_PROPERTIES_VISITOR_EMAIL_FIELD_VISIBLE',
    VMS_INVITE_PROPERTIES_VISITOR_TYPE_FIELD_VISIBLE: 'VMS_INVITE_PROPERTIES_VISITOR_TYPE_FIELD_VISIBLE',
    VMS_INVITE_PROPERTIES_HOST_EMAIL_FIELD_VISIBLE: 'VMS_INVITE_PROPERTIES_HOST_EMAIL_FIELD_VISIBLE',

};
